import React from 'react';

// Text-only brand wordmark — replaces the old symbol logo (assets/coord-logo-path.png).
// Rendered as a span so it keeps DM Sans (headings default to Source Serif 4).
const SIZES = {
  sm: 'text-xl',
  md: 'text-2xl',
  lg: 'text-3xl',
};

const Wordmark = ({ size = 'md', className = '' }) => (
  <span
    className={`font-sans font-bold tracking-tight text-text-primary select-none ${SIZES[size] || SIZES.md} ${className}`}
  >
    Coord
  </span>
);

export default Wordmark;
